<div class="appLayout">
  <ngx-spinner></ngx-spinner>
  <div style="margin-top: 20px;color: rgba(255,255,255,0.6);" [innerHTML]='errorMessage | safeHtml'></div>
  <div style="height: 20px;">.</div>
</div>
